import { Box, Grid, makeStyles, Typography } from "@material-ui/core";
import { ToggleButtonGroup, ToggleButton } from "@material-ui/lab";
import React, { useState } from "react";
import { useParams, useHistory } from "react-router-dom";
import { Error, Loading, useTranslate } from "react-admin";

import SfBreadcrumbs from "../../../components/SfBreadcrumbs";
//import Star from "../../../assets/icons/star.png";
import Person from "../../../assets/icons/person.png";
import Heart from "../../../assets/icons/heart.png";
//import Chat from "../../../assets/icons/chat.png";
//import Badges from "../../../assets/icons/badges.png";

import TagIcon from "../../../assets/icons/tags.png";
//import CreditCard from "../../../assets/icons/credit-card.png";
import MemberInfoPanel from "../../../components/MemberInfoPanel";
import BigTab from "../../../components/BigTab";
import useOneMember from "../../../hooks/useOneMember";
import TransactionsView from "./TransactionsView";
import PointasCashView from "./PointasCashView";

const useStyles = makeStyles((theme) => ({
  container: {
    display: "flex",
    margin: "0px",
    width: "100%",
    height: "100%",
    position: "relative",
    top: 0,
    bottom: 0,
  },
  contentContainer: {
    position: "absolute",
    top: 0,
    bottom: 0,
  },
  leftSideContainer: {
    marginTop: 0,
    flex: 4,
    backgroundColor: theme.gray,
    width: "100%",
    height: "100%",
    overflowY: "auto",
  },
  rightSideContainer: {
    marginTop: 0,
    flex: 2,
    backgroundColor: theme.white,
  },
  containerToggleButton: {
    display: "flex",
    margin: " 0 0px",
  },
  toggleButton: {
    flex: "1",
    margin: "20px 0",
    borderRadius: 0,
    "&$selected": {
      color: theme.white,
      backgroundColor: theme.orange + "!important",
    },
  },
  selected: {},
  deSelectedtextTopToggleButton: { color: theme.orange },
  selectedTextTopToggleButton: { color: theme.white },
  searchBox: {
    display: "flex",
    justifyContent: "center",
  },
  bigTab: {
    width: 136,
    height: 136,
    alignSelf: "center",
    margin: "10px",
    boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
    borderRadius: "10px",
  },
  containerBigTab: {
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "center",
  },
  contentBigTab: {
    display: "grid",
    gridTemplateRows: "50% 50%",
    gridGap: 5,
    alignItems: "center",
    justifyItems: "center",
  },
  onlyWhiteColor: {
    color: theme.white,
  },
  icon: {
    display: "block",
    width: "auto",
    height: "auto",
    maxWidth: 48,
    maxHeight: 48,
    marginRight: 6,
  },
  filterButton: {
    backgroundColor: theme.orange,
    height: 50,
    minWidth: 50,
    width: 50,
    margin: "10px ",
    borderRadius: 8,
  },
}));

function CustomerInsightPageMemberProfiles() {
  const classes = useStyles();

  const [topToggleValue, setTopToggleValue] = useState("Profile");
  const { id } = useParams();
  const history = useHistory();
  const translate = useTranslate();

  const { member: memberInfo, loading, error } = useOneMember(id);

  if (loading) return <Loading />;
  if (error) {
    history.push({
      pathname: `/login`,
    });
    return <Error error />;
  }

  const handleTopToggleValue = (_, newValue) => {
    if (newValue) {
      setTopToggleValue(newValue);
    }
  };

  const bigTabButtonLists = [
    //{ name: "Business Specific", icon: Star },
    {
      name: translate("ra.text.General_information"),
      icon: Person,
      onClick: () =>
        history.push({
          pathname: `/ci/member/profiles/${memberInfo.id}/general`,
        }),
    },
    {
      name: translate("ra.text.personasandInformation"),
      icon: Heart,
      onClick: () =>
        history.push({
          pathname: `/ci/member/profiles/${memberInfo.id}/persona`,
        }),
    },
    //  { name: "Referral", icon: Chat },
    //  { name: "Badges", icon: Badges },
    // {
    //   name: "Social Channel",
    //   icon: FacebookCircle,
    //   onClick: () =>
    //     history.push({
    //       pathname: `/ci/member/profiles/${memberInfo.id}/social`,
    //     }),
    // },
    //{ name: "Payment Method", icon: CreditCard },
    {
      name: translate("ra.text.ci.tags"),
      icon: TagIcon,
      onClick: () =>
        history.push({
          pathname: `/ci/member/profiles/${memberInfo.id}/tags`,
        }),
    },
  ];

  return (
    <Box className={classes.container}>
      <Grid className={classes.contentContainer} container>
        <Grid className={classes.leftSideContainer} item xs={8}>
          <Box>
            <SfBreadcrumbs path={`/Customer Insight/Member/Profile`} lower />
            <ToggleButtonGroup
              value={topToggleValue}
              exclusive
              onChange={handleTopToggleValue}
              classes={{ root: classes.containerToggleButton }}
            >
              <ToggleButton
                value="Profile"
                aria-label="Profile"
                classes={{
                  root: classes.toggleButton,
                  selected: classes.selected,
                }}
              >
                <Typography
                  className={
                    topToggleValue === "Profile"
                      ? classes.selectedTextTopToggleButton
                      : classes.deSelectedtextTopToggleButton
                  }
                >
                  {translate("ra.text.ci.profile")}
                </Typography>
              </ToggleButton>

              <ToggleButton
                value="Wallet"
                aria-label="wallet"
                classes={{
                  root: classes.toggleButton,
                  selected: classes.selected,
                }}
              >
                <Typography
                  className={
                    topToggleValue === "Wallet"
                      ? classes.selectedTextTopToggleButton
                      : classes.deSelectedtextTopToggleButton
                  }
                >
                  {translate("ra.text.ci.wallet")}
                </Typography>
              </ToggleButton>

              <ToggleButton
                value="Transaction"
                aria-label="transaction"
                classes={{
                  root: classes.toggleButton,
                  selected: classes.selected,
                }}
              >
                <Typography
                  className={
                    topToggleValue === "Transaction"
                      ? classes.selectedTextTopToggleButton
                      : classes.deSelectedtextTopToggleButton
                  }
                >
                  {translate("ra.text.ci.transactions")}
                </Typography>
              </ToggleButton>
            </ToggleButtonGroup>
          </Box>
          {topToggleValue === "Profile" ? (
            <Box>
              <Box className={classes.containerBigTab}>
                {bigTabButtonLists.map((element, index) => {
                  return (
                    <BigTab
                      key={index}
                      className={classes.bigTab}
                      onClick={element.onClick}
                    >
                      <Box className={classes.contentBigTab}>
                        <img
                          draggable={false}
                          className={classes.icon}
                          src={element.icon}
                          alt={element.name}
                        />
                        <Typography className={classes.onlyWhiteColor}>
                          {element.name}
                        </Typography>
                      </Box>
                    </BigTab>
                  );
                })}
              </Box>
            </Box>
          ) : topToggleValue === "Wallet" ? (
            <>
              <Typography align="center" variant="h4">
                {translate("ra.text.pointasCashWalletTitle")}
              </Typography>
              <PointasCashView id={id} />
            </>
          ) : (
            <>
              <Typography align="center" variant="h4">
                {translate("ra.text.ci.transactions")}
              </Typography>
              <TransactionsView id={id} />
            </>
          )}
        </Grid>
        <Grid xs={4} className={classes.rightSideContainer}>
          <MemberInfoPanel id={memberInfo.id} />
        </Grid>
      </Grid>
    </Box>
  );
}

export default CustomerInsightPageMemberProfiles;
